import React from 'react';
import PropTypes from 'prop-types';
import * as I18n from 'circe/I18n';
import Grid from 'pencil/Grid';
import TextField from 'pencil/TextField';
import FileField from 'circe/forms/fields/FileField';
import FieldTitle from './FieldTitle';
import PersonalInformation from './PersonalInformation';

const VehicleDocuments = (props) => {
  const { name } = props;

  return (
    <>
      <FieldTitle title={I18n.str('vehicleInsurance', "Vehicle's Insurance")} />

      <FileField label={I18n.str('insurance', 'Insurance')} name={`${name}insurance`} />

      <FieldTitle title={I18n.str('vehicleRegistration', "Vehicle's Registration")} />

      <FileField label={I18n.str('front', 'Front')} name={`${name}registrationFront`} />
    </>
  );
};

VehicleDocuments.propTypes = {
  name: PropTypes.string,
};

VehicleDocuments.defaultProps = {
  name: '',
};

export default VehicleDocuments;
